import http from '@/http/aisea/axios'
const resource = "/manning/vessels/categories";

export default {

  search() {
    return http.get(`${resource}`);
  },

};
